// src/components/LoadingBouncyDots.js
import React from "react";

export default function LoadingBouncyDots({
  text = "Checking for latest…",
  colors = ["#05B2D6", "#EE3132", "#F37E2B", "#6EBE45"], // primary, red, amber, green
  size = 10, // dot diameter in px
  gap = 4, // gap between dots in px
  speed = 800, // bounce duration in ms
  className = "",
  textClassName = "text-xs text-typography/60",
}) {
  return (
    <div
      className={`flex flex-col items-center gap-1 ${className}`}
      role="status"
      aria-live="polite"
    >
      <style>{`
        @keyframes dot-bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-40%); }
        }
        .dot {
          display: inline-block;
          border-radius: 9999px;
          animation-name: dot-bounce;
          animation-timing-function: cubic-bezier(.6,.05,.2,.9);
          animation-iteration-count: infinite;
        }
      `}</style>

      <div
        className="flex items-end"
        style={{ columnGap: `${gap}px` }}
        aria-hidden="true"
      >
        {colors.map((c, i) => (
          <span
            key={i}
            className="dot"
            style={{
              width: size,
              height: size,
              backgroundColor: c,
              animationDuration: `${speed}ms`,
              animationDelay: `${i * (speed / 6)}ms`,
            }}
          />
        ))}
      </div>

      <div className={textClassName}>{text}</div>
    </div>
  );
}
